<div class="separar-fecha-hora">
    <label for="separar-fecha-hora-checkbox" name="nombreEtiqueta">{{ lenguage === 'en' ? etiqueta.nombreEn : etiqueta.nombre }}</label>
    <input type="checkbox" name="separar-fecha-hora-checkbox" class="separar-fecha-hora__checkbox"
        [(ngModel)]="etiqueta.estado">
</div>